// @ts-ignore
export const DIRECT_CITY: [{city: string, town: Array<string>}] = [
  {
    city: 'PARIS',
    town: [
      '229 rue Saint-Honoré, 75001',
      '9 rue des colonnes, 75002',
      '10 rue Greneta, 75003',
      '66 Avenue des Champs-Élysées, 75008',
      '128 Rue La Boétie, 75008',
      '49 Rue de Ponthieu, 75008',
      '24 rue de Clichy, 75009',
      '39 Rue de la Gare de Reuilly, 75012',
      '154 Ter Avenue Victor Hugo, 75116'
    ]},
  {
    city: 'Ile-de-France',
    town: [
      '7 Place de l\'Hôtel de Ville, 93600, Aulnay-sous-Bois',
      '5 Avenue du Général de Gaulle, 94160, Saint-Mandé',
      '3 Rue Jules Guesde, 91130, Ris-Orangis',
      '6 Rue des Bateliers, 92110, Clichy',
      '14/30 rue de Mantes, 92700, Colombes',
      '65 rue de la Croix, 92000, Malakoff',
      '32 Rue Guy Môquet, 92240, Malakoff',
      '6 Avenue de la Libération, 92350, Le Plessis-Robinson'
    ]},
  {
    city: 'LYON',
    town: [
      '18/20 Rue Tronchet, 69006',
      '4 rue de la république, 69001'
    ]
  },
  {
    city: 'LILLE', town: [
      '229 rue Solférino, 59000',
      '104 rue Nationale, 59800'
    ]
  },
  {
    city: 'BORDEAUX',
    town: [
      '104 rue Nationale, 59800',
      '5 Allées de Tourny, 33000',
      '117 Quai de Bacalan, 33300'
    ]
  },
  {
    city: 'MARSEILLE',
    town: [
      '69 Rue du Rouet, 13008'
    ]
  },
  {
    city: 'NANTES',
    town: [
      '41- 43 Quai de Malakoff, 44000',
      '17 boulevard de Berlin, 44000'
    ]
  },
  {
    city: 'TOULOUSE',
    town: [
      '13 rue Sainte Ursule, 31000, Montpelier',
      '19 rue Rigaud, 34000, Montpelier'
    ]
  },
  {
    city: 'MONTPELLIER',
    town: [
      '19 rue Rigaud, 34000, Montpellier'
    ]
  },
  {
    city: 'STRASBOURG',
    town: [
      '1 Rue des Sœurs, 67400, Illkirch-Graffenstaden'
    ]
  },
  {
    city: 'NICE',
    town: [
      '10 Rue Blacas, 06000, Nice'
    ]
  },
  {
    city: 'RENNES',
    town: [
      '28 Boulevard du Colombier, 35000',
      '90 Bis rue de Fougères, 35700',
      '6B Rue du Bas Village, 35510'
    ]
  },
  {
    city: 'ANTIBES',
    town: [
      '82 Boulevard du Président Wilson, 06160, Antibes-Juan-Les-Pins'
    ]
  },
  {
    city: 'Saint RaphaËL',
    town: [
      '40 Boulevard Jean Moulin, 83700, Saint-Raphaël'
    ]
  }
];
export const paris = [
  '229 rue Saint-Honoré, 75001',
  '9 rue des colonnes, 75002',
  '10 rue Greneta, 75003',
  '66 Avenue des Champs-Élysées, 75008',
  '128 Rue La Boétie, 75008',
  '49 Rue de Ponthieu, 75008',
  '24 rue de Clichy, 75009',
  '39 Rue de la Gare de Reuilly, 75012',
  '154 Ter Avenue Victor Hugo, 75116'
];
export const ileDeFrance: Array<string> = [
  '7 Place de l\'Hôtel de Ville, 93600, Aulnay-sous-Bois',
  '5 Avenue du Général de Gaulle, 94160, Saint-Mandé',
  '3 Rue Jules Guesde, 91130, Ris-Orangis',
  '6 Rue des Bateliers, 92110, Clichy',
  '14/30 rue de Mantes, 92700, Colombes',
  '65 rue de la Croix, 92000, Malakoff',
  '32 Rue Guy Môquet, 92240, Malakoff',
  '6 Avenue de la Libération, 92350, Le Plessis-Robinson'
];
export const lyon = [
  '18/20 Rue Tronchet, 69006',
  '4 rue de la république, 69001'
];
export const lille = [
  '229 rue Solférino, 59000',
  '104 rue Nationale, 59800'
];
export const bordeaux = [
  '104 rue Nationale, 59800',
  '5 Allées de Tourny, 33000',
  '117 Quai de Bacalan, 33300'
];
export const marseille = [
  '69 Rue du Rouet, 13008 '
];
export  const nantes = [
  '41- 43 Quai de Malakoff, 44000',
  '17 boulevard de Berlin, 44000'
];
export const toulouse = [
  '13 rue Sainte Ursule, 31000, Montpelier',
  '19 rue Rigaud, 34000, Montpelier'
];
export const montpellier = [
  '19 rue Rigaud, 34000, Montpellier'
];
export const strasbourg = [
  '1 Rue des Sœurs, 67400, Illkirch-Graffenstaden'
];
export const nice = [
  '10 Rue Blacas, 06000, Nice'
];
export const rennes = [
  '28 Boulevard du Colombier, 35000',
  '90 Bis rue de Fougères, 35700',
  '6B Rue du Bas Village, 35510'
];
export const antibes = [
  '82 Boulevard du Président Wilson, 06160, Antibes-Juan-Les-Pins'
];
export const saintRaphael = [
  '40 Boulevard Jean Moulin, 83700, Saint-Raphaël'
];
